// Appends a cache-busting timestamp to a URL. Preserves existing query params if present. @param url - The original URL @returns The cache-busted URL
export const cacheBustUrl = (url: string): string => {
  const hasQuery = url.includes("?");
  const separator = hasQuery ? "&" : "?";
  const timestamp = Date.now();
  const key = "t";
  return `${url}${separator}${key}=${timestamp}`;
};
